/**
 * Copies search form to offcanvas
 */

document.addEventListener("DOMContentLoaded", () => {
	// Select the first element with the class "component form search"
	const searchNode = document.querySelector(".component.form.search");

	// Clone search form
	if ( searchNode ) {
		// Clone the selected element
		const searchClone = searchNode.cloneNode(true);

		// Select the first element with the class "section offcanvas search" and append the cloned element to its "middle" class
		document.querySelector(".section.offcanvas.search .middle").appendChild(searchClone);
	}
});